// extracted by mini-css-extract-plugin
export default {"incoming":"IncomingCall_incoming__dvTeU","decline":"IncomingCall_decline__DXS+M"};